module.exports = __webpack_public_path__ + "img/过程映射.0ea5aeae.svg";